import React from 'react';
import PropTypes from "prop-types";
import { Component } from 'react'

import './style.css';

export default class SelectBusinessOption extends Component {
  static propTypes = {
    googlePlaceSearchItem: PropTypes.object
  };

  render() {
    let place = this.props.googlePlaceSearchItem;

    if (place.hintItem) {
      return (
        <div>
          <div className="select-business-place-hint">
            Can't find your store? Try adding your city
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="select-business-place-option-name">
            {place.name}
          </div>
          <div className="select-business-place-option-address">
            {place.address}
          </div>
        </div>
      );
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SelectBusinessOption/index.js
 **/